/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable indent */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import {
  Grid,
  InputLabel,
  MenuItem,
  Input,
  Select,
  Button,
} from '@material-ui/core';
import { Toast } from 'components/Toast';
import { getFriendlyErrorMessage } from 'utils/errorHelper';
import { UserService } from 'services/User/UserService';
import useStyles from './styles';

interface IReplicatorFormProps {
  query_f: (variables: any) => Promise<any>;
}

export const ReplicatorForm: React.FC<IReplicatorFormProps> = ({ query_f }) => {
  const classes = useStyles();

  const sites = UserService.useSitesFromAccess();

  const [siteId, setSiteId] = useState();
  const [urls, setUrls] = useState([]);

  const saveContent = () => {
    const variables = {
      urls,
      siteId,
    };

    query_f({
      variables,
    }).then(
      () => {
        Toast('Action executed with success!');
      },
      (error) => {
        Toast(getFriendlyErrorMessage(error), 'error');
      },
    );
  };

  const handleFileUpload = (e: any) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event: any) => {
      const text = event.target.result;
      if (!text) return;

      const lines = text.split('\n');

      const tableHeaderToCompare = 'URL,Publish Date';
      const tableHeader = lines[0].trim();

      if (tableHeaderToCompare !== tableHeader) {
        Toast(
          'Invalid table, follow the suggested template: (URL, Publish Date)',
          'error',
        );
        return;
      }

      const data = lines.slice(1).map((line: any) => {
        const [url, publishDate] = line.split(',');
        return { url, publishDate };
      });

      setUrls(data);
    };

    reader.readAsText(file);
  };

  const handleSitesChange = (site: any) => {
    if (site.target.value === 'null') setSiteId(undefined);
    else setSiteId(site.target.value);
  };

  return (
    <>
      <form id="myForm">
        <Grid container spacing={1}>
          <Grid item xs={8}>
            <InputLabel>Sites</InputLabel>
            <Select
              id="sites-lookup-id"
              value={siteId}
              onChange={handleSitesChange}
              input={<Input />}
              style={{ width: '100%' }}
            >
              <MenuItem key="null" value="null" selected />
              {sites ? (
                sites.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))
              ) : (
                <></>
              )}
            </Select>
          </Grid>
          <Grid item xs={4}>
            <div
              className="send-file"
              style={{
                width: '100%',
                display: 'inline-block',
                marginTop: '10px',
              }}
            >
              <label
                htmlFor="fileInput"
                style={{
                  color: '#fff',
                  backgroundColor: '#78001b',
                  borderColor: '#007bff',
                  cursor: 'pointer',
                  padding: '.35rem .5rem',
                  fontSize: '.875rem',
                  lineHeight: 1.5,
                  borderRadius: '.2rem',
                  opacity: !siteId ? 0.5 : 1,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  textTransform: 'uppercase',
                }}
              >
                <input
                  type="file"
                  id="fileInput"
                  hidden
                  accept=".csv"
                  onChange={handleFileUpload}
                  disabled={!siteId}
                />
                Upload .CSV
              </label>
            </div>
          </Grid>

          <Grid item xs={12}>
            <Button
              onClick={() => saveContent()}
              fullWidth
              variant="contained"
              className={classes.btnSave}
              disabled={urls.length === 0}
            >
              Send
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};
